"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClient = exports.typeParser = exports.APIError = void 0;
const axios_1 = __importStar(require("axios"));
class APIError extends Error {
}
exports.APIError = APIError;
exports.typeParser = {
    date: (data) => {
        return new Date(data);
    },
};
/**
 * provides default request API to any extending classes.
 */
class BaseClient {
    /**
     * @param baseUrl url for the service
     * @param getHeaders any custom headers to be sent with every request, using a function here to allow for dynamic headers
     * @param defaultTimeout default timeout for requests in milliseconds. If undefined no timeout
     * @param modules optional map of module names to module classes. This is used to automatically
     *                instantiate the modules and make them available on the client instance
     * @param getUrlSuffix optional function to auto-append a suffix to every request url, useful for case like god-mode in studio-client where we append ?god=<address> to every request
     * @param fieldsToParseMapping default optional map of fields to parse in the response.
     * @example { date: ['created_at', 'updated_at'] }
     */
    constructor({ baseUrl, getHeaders, defaultTimeout, modules = {}, getDefaultQueryParams, fieldsToParseMapping, }) {
        this.baseUrl = baseUrl;
        this.getDefaultQueryParams = getDefaultQueryParams;
        this._fieldsToParseMapping = fieldsToParseMapping;
        if (getHeaders) {
            this.getHeaders = () => {
                const headers = getHeaders();
                const axiosHeaders = new axios_1.AxiosHeaders();
                for (const key of Object.keys(headers)) {
                    axiosHeaders.set(key, headers[key]);
                }
                return new axios_1.AxiosHeaders(axiosHeaders);
            };
        }
        this.defaultTimeout = defaultTimeout;
        // instantiate the modules and make them available on the client instance
        const moduleInstances = {};
        Object.keys(modules).forEach((moduleName) => {
            const moduleInstance = new modules[moduleName](this);
            moduleInstances[moduleName] = moduleInstance;
            Object.defineProperty(this, moduleName, {
                enumerable: true,
                get() {
                    return moduleInstance;
                },
            });
        });
        this.moduleInstances = moduleInstances;
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    get(path, config = {}, fieldsToParseMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(path, 'get', config, fieldsToParseMapping);
        });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    post(path, config = {}, fieldsToParseMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(path, 'post', config, fieldsToParseMapping);
        });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    put(path, config = {}, fieldsToParseMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(path, 'put', config, fieldsToParseMapping);
        });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    patch(path, config = {}, fieldsToParseMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(path, 'patch', config, fieldsToParseMapping);
        });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    delete(path, config = {}, fieldsToParseMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(path, 'delete', config, fieldsToParseMapping);
        });
    }
    /**
     * @param fieldsToParseMapping optional map of fields to parse in the response, will override the default fieldsToParseMapping completely
     */
    request(path, method, config, fieldsToParseMapping) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const requestConfig = Object.assign({}, config);
            if (this.getHeaders) {
                requestConfig.headers = Object.assign(Object.assign({}, this.getHeaders()), config.headers);
            }
            if (this.getDefaultQueryParams) {
                requestConfig.params = Object.assign(Object.assign({}, this.getDefaultQueryParams()), config.params);
            }
            requestConfig.timeout = (_a = config.timeout) !== null && _a !== void 0 ? _a : this.defaultTimeout;
            const query = axios_1.default[method];
            // If you are doing axios post, put, or patch, you must pass data separately
            // from the config object. This is a limitation of axios.
            let response;
            if (method === 'post' || method === 'put' || method === 'patch') {
                // configRest contains headers, timeout, etc.
                const { data } = requestConfig, configRest = __rest(requestConfig, ["data"]);
                response = yield query(`${this.baseUrl}${path}`, data, Object.assign({}, configRest));
            }
            else {
                response = yield query(`${this.baseUrl}${path}`, requestConfig);
            }
            const responseJson = response.data;
            if (response.status >= 300) {
                const error = new APIError(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (_b = responseJson.error) !== null && _b !== void 0 ? _b : `Received status '${response.status}' from server for '${path}'`);
                error.statusCode = response.status;
                console.error(error);
                throw error;
            }
            return this._processResponse(responseJson, fieldsToParseMapping || this._fieldsToParseMapping);
        });
    }
    _processResponse(data, fieldsToParseMapping) {
        if (fieldsToParseMapping) {
            for (const type of Object.keys(fieldsToParseMapping)) {
                const parseType = type;
                /**
                 * Note: typeof data === 'object' also take into account arrays, since arrays are objects in JS.
                 * Ex: typeof [1,2] === 'object' // true.
                 * Const keys = object.keys([1,2]) // keys = ['0', '1']
                 */
                if (typeof data === 'object') {
                    // If the data is an array, we only iterate over object items within the array
                    if (Array.isArray(data)) {
                        for (const value of data) {
                            if (typeof value === 'object') {
                                this._recursiveConverter(parseType, value, fieldsToParseMapping[parseType]);
                            }
                        }
                        return data;
                    }
                    const object = data;
                    this._recursiveConverter(parseType, object, fieldsToParseMapping[parseType]);
                }
            }
        }
        return data;
    }
    _recursiveConverter(parseType, data, // using unknown here sine we have no way of knowing the type and structure of the response object from the server
    fields) {
        for (const key of Object.keys(data)) {
            if (!data[key]) {
                continue;
            }
            if (typeof data[key] === 'object') {
                this._recursiveConverter(parseType, data[key], fields);
            }
            for (const field of fields) {
                if (key === field) {
                    if (Array.isArray(data[key])) {
                        data[key] = data[key].map((item) => {
                            if (typeof item === 'string' || typeof item === 'number') {
                                return exports.typeParser[parseType](item);
                            }
                            return item;
                        });
                        continue;
                    }
                    if (typeof data[key] === 'string' || typeof data[key] === 'number') {
                        data[key] = exports.typeParser[parseType](data[key]);
                    }
                }
            }
        }
    }
}
exports.BaseClient = BaseClient;
//# sourceMappingURL=baseClient.js.map